
    import * as React from 'react';

    const ChevronRightCircle40 = ({ color = 'currentcolor', height = '40px', width = '40px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 40 40" fill="none" style={svgStyle}><g><path fillRule="evenodd" clipRule="evenodd" d="M1 20C1 30.4934 9.50659 39 20 39C30.4934 39 39 30.4934 39 20C39 9.50659 30.4934 1 20 1C9.50659 1 1 9.50659 1 20ZM20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0Z" /><path fillRule="evenodd" clipRule="evenodd" d="M24.7072 20L16.3536 28.3535L15.6465 27.6464L23.2929 20L15.6465 12.3535L16.3536 11.6464L24.7072 20Z" /></g></svg>
        </div>
      );
    };

    ChevronRightCircle40.displayName = 'ChevronRightCircle40';

    export default ChevronRightCircle40;
  